import {Button, Stack} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';
import {UnitNetworkHeader} from 'presentation/modules/booking/shared/ui/components/UnitNetworkHeader';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useHealthUnitsAccreditedNetwork} from './hooks/useHealthUnitsAccreditedNetwork';
import {HealthUnitsAccreditedNetworkProps} from './types';

const {accreditedNetwork, changeAppointmentLocal} =
	translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function HealthUnitsAccreditedNetwork({unitsList}: HealthUnitsAccreditedNetworkProps) {
	const {
		listIsEmpty,
		isMobile,
		handleChangeModals,
		specialtyName,
		query,
		shouldReverseNetworkOrder,
	} = useHealthUnitsAccreditedNetwork({unitsList});

	if (listIsEmpty) {
		if (query) return null;

		return (
			<Stack gap={2} mt={shouldReverseNetworkOrder ? 0 : 2}>
				<UnitNetworkHeader
					title={accreditedNetwork.title}
					description={accreditedNetwork.emptyDescription}
				/>
				<Button
					variant="outlined"
					sx={{width: isMobile ? '100%' : '330px', ml: 'auto'}}
					size="large"
					onClick={() => handleChangeModals(ChangeFlowVariantEnum.LOCATION)}
					data-tag-id={AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO}>
					{changeAppointmentLocal}
				</Button>
			</Stack>
		);
	}

	return (
		<Stack gap={2}>
			<UnitNetworkHeader
				title={accreditedNetwork.title}
				description={accreditedNetwork.phoneScheduleDescription}
			/>

			<Grid container spacing={2}>
				{unitsList?.map((unit, index) => {
					return (
						<Grid
							key={`${unit.name}-${unit.formattedAddress}${index}`}
							size={{xs: isMobile ? 12 : 6}}>
							<UnitCard
								query={query}
								isNotSelf={true}
								onClick={() => {}}
								unitName={unit?.name}
								address={unit?.formattedAddress}
								nmBairroOrigem={unit?.nmBairroOrigem}
								isTelemedicine={false}
								distanceReference={unit?.distance}
								specialtyName={specialtyName}
								phoneNumbers={unit?.phoneNumbers}
								showDistanceReference={
									unit?.distance !== undefined && unit?.distance !== null
								}
							/>
						</Grid>
					);
				})}
			</Grid>
		</Stack>
	);
}
